/**
 * Persistent State Utility
 * Helper to persist component state in sessionStorage to survive navigation
 */

interface InventoryState {
    page: number;
    limit: number;
    productType: string;
    category: string;
    companyId: string;
    showFilters: boolean;
    searchTerm: string;
    searchInput: string;
}

const INVENTORY_STATE_KEY = 'inventory_page_state';

export const saveInventoryState = (state: Partial<InventoryState>) => {
    try {
        const existing = getInventoryState() || {};
        const updated = { ...existing, ...state };
        sessionStorage.setItem(INVENTORY_STATE_KEY, JSON.stringify(updated));
    } catch (e) {
        console.error('Error saving inventory state:', e);
    }
};

export const getInventoryState = (): InventoryState | null => {
    try {
        const saved = sessionStorage.getItem(INVENTORY_STATE_KEY);
        if (saved) {
            return JSON.parse(saved);
        }
    } catch (e) {
        console.error('Error getting inventory state:', e);
    }
    return null;
};

export const clearInventoryState = () => {
    sessionStorage.removeItem(INVENTORY_STATE_KEY);
};
